import { commonEN, commonPT, commonES } from './translations/common';
import { homeEN, homePT, homeES } from './translations/home';
import { manifestoEN, manifestoPT, manifestoES } from './translations/manifesto';
import { servicesEN, servicesPT, servicesES } from './translations/services';
import { industriesEN, industriesPT, industriesES } from './translations/industries';
import { contactEN, contactPT, contactES } from './translations/contact';

const en = { ...commonEN, ...homeEN, ...manifestoEN, ...servicesEN, ...industriesEN, ...contactEN };
const pt = { ...commonPT, ...homePT, ...manifestoPT, ...servicesPT, ...industriesPT, ...contactPT };
const es = { ...commonES, ...homeES, ...manifestoES, ...servicesES, ...industriesES, ...contactES };

export type Language = 'EN' | 'PT' | 'ES';
export type TranslationKey = keyof typeof en;
export type Translations = Record<TranslationKey, string>;
export const translations: Record<Language, Translations> = { EN: en, PT: pt, ES: es };
